//const serverUrl ='http://localhost:8080'
// const serverUrl ='http://114.55.27.39:8089'
const serverUrl = 'http://ipmsvip.com:8089'

global.constants = {
    serverUrl: serverUrl,
    login: serverUrl + '/user/login',//登陆接口
    register: serverUrl + '/user/register',//注册接口
    checkPhone:serverUrl+'/user/checkPhone',//实时检测用户输入的用户名是否重复
    logout: serverUrl + '/user/logout ',//退出登录接口
    findPhone: serverUrl + '/user/findPhone',//忘记密码中检查手机号是否已被注册
    findPassword: serverUrl + '/user/findPassword',//向后端传送新密码
    getUserMessage:serverUrl+'/user/getUserMessage',//获取用户信息
    updateUser:serverUrl+'/user/updateUser',//用户自己修改信息
    updatePassword:serverUrl+'/user/updatePassword',//用户自己修改密码
    updatePhone:serverUrl+'/user/updatePhone',//用户自己换绑手机号
    getCompanyList: serverUrl + '/company/main',//获取公司列表
    getCompanyNameList: serverUrl + '/company/getCompanyNameList',//获取用户全部公司名称
    addCompany: serverUrl + '/company/addCompany',//添加公司
    checkCompanyName: serverUrl+'/company/checkCompanyName',//实时检测用户输入的公司名是否重复
    getCompany: serverUrl + '/company/getCompany',//查找单个公司信息
    alterCompany: serverUrl + '/company/alterCompany',//修改公司信息
    deleteCompany: serverUrl + '/company/deleteCompany',//删除公司
    checkProcess:serverUrl + '/company/checkProcess',//公司进度检查
    getOneLevel:serverUrl +'/company/getOneLevel',//获取一级技术领域名称列表
    getTwoLevel:serverUrl + '/company/getTwoLevel',//获取二级技术领域名称列表
    getThreeLevel:serverUrl + '/company/getThreeLevel',//获取三级技术领域名称列表
    getAllProduct: serverUrl + '/product/getAllProduct',//获取用户全部产品对象
    getProductNameList: serverUrl + '/product/getProductNameList',//获取某公司全部产品名称
    getCompanyProductList: serverUrl + '/product/main',//获取某一公司的高新产品列表
    addProduct: serverUrl +'/product/addProduct',//添加高品
    checkProductName:serverUrl+'/product/checkProductName',//实时检测用户输入的产品名是否重复
    getProduct: serverUrl + '/product/getProduct',//查询单个产品
    alterProduct: serverUrl + '/product/alterProduct',//修改产品信息
    updateProductTechnology: serverUrl + '/product/updateProductTechnology',//更新高品的关键技术
    updateProductAdvantage: serverUrl + '/product/updateProductAdvantage',//更新高品的竞争优势
    updateProductTarget: serverUrl + '/product/updateProductTarget',//更新高品的技术指标
    deleteProduct: serverUrl  + '/product/deleteProduct',//删除产品
    getProjectByCompany:serverUrl +'/project/getProjectByCompany',//获取项目列表-根据公司名
    getProjectByProduct:serverUrl +'/project/getProjectByCompanyAndProduct',//获取项目列表-根据公司名和产品名
    getProjectByYear:serverUrl+ '/project/getProjectByYear',//获取项目列表-根据年份和公司名
    getProjectNameByCompanyNameList: serverUrl + '/project/getProjectNameByCompanyNameList',//获取项目名称列表-根据公司名
    getProjectNameByCompanyProductNameList:serverUrl + '/project/getProjectNameByCompanyProductNameList',//获取项目名称列表-根据公司名和产品名
    getAllProject:serverUrl  + '/project/getAllProject',//获取该用户的所有项目
    addProject:serverUrl+'/project/addProject',//增加项目
    checkProjectName:serverUrl+'/project/checkProjectName',//实时检测用户输入的项目名是否重复
    getProjectMessage:serverUrl+'/project/getProjectMessage',//获取单个项目信息
    updateProject:serverUrl+'/project/updateProject',//修改项目
    deleteProject:serverUrl+'/project/deleteProject',//删除项目
    getAllPatent: serverUrl + '/patent/getAllPatent',//获取某公司全部知识产权对象列表
    getPatentByCompany:serverUrl + '/patent/getPatentByCompany',//根据公司名称获取知识产权对象列表
    getPatentByProduct: serverUrl + '/patent/getPatentByProduct',//根据产品名称获取知识产权对象列表
    getPatentByProject: serverUrl + '/patent/getPatentByProject',//根据项目名称获取知识产权对象列表
    getAllPatentByCompanyName: serverUrl + '/patent/getAllPatentByCompanyName',//根据公司名获取该公司下所有产权
    addPatent: serverUrl + '/patent/addPatent',//增加知识产权
    checkPatentName:serverUrl+'/patent/checkPatentName',//实时检测用户输入的专利名是否重复
    getPatentMessage: serverUrl + '/patent/getPatentMessage',//获取单个知识产权
    updatePatent: serverUrl + '/patent/updatePatent',//修改知识产权信息
    deletePatent: serverUrl + '/patent/deletePatent',//删除知识产权
    updatePatentSurvey: serverUrl + '/patent/updateSurvey',//更新知识产权概述
    updatePatentIntroduction: serverUrl + '/patent/updateIntroduction',//更新知识产权介绍
    updateTransfer: serverUrl + '/patent/updateTransfer',//更新科技成果转化形式
    updateEfficiency: serverUrl + '/template/updateEfficiency',//更新科技成果应用成效
    getPatentApplying: serverUrl + '/patent/getPatentApplying',//获取一个公司申请中的知识产权对象
    getPatentAuthorized: serverUrl + '/patent/getPatentAuthorized',//获取一个公司已授权的知识产权对象
    getPatentAccessA: serverUrl + '/patent/getPatentAccessA',//获取一个公司自主研发的知识产权
    getPatentAccessB: serverUrl + '/patent/getPatentAccessB',//获取受让、受赠或并购的知识产权
    getFieldTemplateGetA: serverUrl + '/template/getA',//获取A模板技术领域说明的数据
    UpdateFieldTemplateA:serverUrl+'/template/UpdateA',//修改模板A内容
    exportFieldTemplateA: serverUrl + '/template/A',//生成技术领域说明模板A
    getIPNonReuseTemplateB: serverUrl + '/template/getB',//获取知识产权未重复使用说明的数据
    updateIPNonReuseTemplateB:serverUrl+'/template/updateB',//修改知识产权为重复使用说明
    exportTemplateB: serverUrl +'/template/B',//生成未重复使用说明模板B
    exportTemplateC: serverUrl + '/template/C',//生成知识产权汇总表
    exportPatentSurvey: serverUrl + '/template/patentSurvey',//生成知识产权概况
    exportPatentIntroduction:serverUrl+'/template/patentIntroduction',//生成知识产权对主要产品（服务）在技术上发挥和信心作用介绍
    getPatentTransferSummaryGetD: serverUrl + '/template/getD',//获取近三年科技成果转化汇总
    PatentTransferSummaryAutoD:serverUrl+ '/template/AutoD',//自动插入数据
    PatentTransferSummaryAddD:serverUrl+ '/template/AddD',//自定义插入数据
    PatentTransferSummaryGetOneD:serverUrl+ '/template/getOneD',//获取单条成果转化表信息
    PatentTransferSummaryUpdateD:serverUrl+ '/template/updateD',//模板D修改单条
    PatentTransferSummaryDeleteD:serverUrl+ '/template/deleteD',//删除D单条数据
    exportPatentTransferSummaryD: serverUrl + '/template/D',//生成科技成果转化汇总
    getOverallConditionGetE: serverUrl + '/template/getE',//获取成果转化总体情况
    updateOverallConditionE:serverUrl+'/template/updateE',//修改科技成果转化总体情况说明
    exportOverallConditionE: serverUrl + '/template/E',//生成成果转化总体情况
    getItemConditionGetF:serverUrl + '/template/getF',//获取科技成果逐项说明内容
    exportItemConditionF:serverUrl+'/template/F',//生成科技成果逐项说明
    getBuildProjectSummaryGetG: serverUrl+'/template/getG',//获取近三年研究开发活动项目一览表数据
    exportBuildProjectSummaryG:serverUrl+'/template/G',//生成近三年研究开发活动项目一览表
    getBuildProjectResolutionGetH: serverUrl+'/template/getH',//更新合并的立项决议
    exportBuildProjectResolutionH:serverUrl+'/template/H',//生成立项决议
    addBuildProjectResolution: serverUrl +'/template/addH',//增加某年立项决议
    getProjectReportGetI: serverUrl + '/template/getI',//获取某项目立项报告
    addProjectReport: serverUrl + '/template/addI',//增加某项目立项报告
    exportProjectReportI: serverUrl + '/template/I',//生成某项目立项报告
    getReceivingReportGetJ: serverUrl + '/template/getJ',//获取某项目结项报告
    addReceivingReport: serverUrl + '/template/addJ',//增加某项目结项报告
    exportReceivingReportJ: serverUrl +'/template/J',//生成某项目结项报告
    getStaffSituationGetK:serverUrl + '/template/getK',//获取人员情况表
    updateStaffSituationK:serverUrl + '/template/updateK',//修改或增加人员情况表内容
    exportStaffSituationK:serverUrl + '/template/K',//生成人员情况表
    getStaffRosterGetL:serverUrl + '/template/getL',//获取人员花名册
    getStaffRosterRemarkL:serverUrl +'/template/getLRemark',//获取人员花名册下面的注
    addStaffRoster:serverUrl + '/template/addL',//修改或增加人员花名册人员
    StaffRosterGetOneL:serverUrl+'/template/getOneL',//获取单个员工
    updateStaffRoster:serverUrl +'/template/updateL',//修改人员信息
    deleteStaffRoster:serverUrl + '/template/deleteL',//删除人员花名册的人员
    exportStaffRosterL:serverUrl+ '/template/L',//生成人员花名册
    getStaffStructureGetM:serverUrl + '/template/getM',//获取某年企业职工人数、学历结构以及研发人员结构情况说明
    updateStaffStructureM:serverUrl + '/template/updateM',//添加和修改江苏人员情况说明
    exportStaffStructureM:serverUrl +'/template/M',//生成人员情况说明表
    getHighTechSpecificGetN:serverUrl +'/template/getN',//获取高品具体说明上的字
    exportHighTechSpecificN:serverUrl+'/template/N',//生成高品具体说明
    getOrganizationOverAllGetO:serverUrl+'/template/getO',//获取研究开发组织管理水平总体情况说明O
    addOrganizationOverAll:serverUrl+'/template/addO',//添加和修改研究开发组织管理水平总体情况说明O
    exportOrganizationOverAllO:serverUrl+'/template/O',//生成研究开发组织管理水平总体情况说明O
    getOrganizationItemGetP:serverUrl+'/template/getP',//获取研究开发组织管理水平指标逐项说明P
    addOrganizationItem:serverUrl+'/template/addP',//添加和删除研究开发组织管理水平指标逐项说明p
    exportOrganizationItemP:serverUrl+'/template/P',//生成研究开发组织管理水平指标逐项说明
    getRDCenterFoundR:serverUrl+'/template/getR',//获取关于成立研发中心的通知R
    updateRDCenterFound:serverUrl+'/template/updateR',//修改关于成立研发中心的通知
    exportRDCenterFoundR:serverUrl+'/template/R',//生成关于成立研发中心的通知
    getRDCenterS:serverUrl+'/template/getS',//获取研发中心建设情况说明S
    updateRDCenter:serverUrl+'/template/updateS',//修改研发中心建设情况说明
    exportRDCenterS:serverUrl+'/template/S',//生成研发中心建设情况说明S
    getRDEquipmentT:serverUrl+'/template/getT',//获取研发设备明细表
    addRDEquipment:serverUrl+'/template/addT',//增加研发设备明细表
    updateRDEquipment:serverUrl+'/template/updateT',//修改研发设备明细表
    deleteRDEquipment:serverUrl+'/template/deleteT',//删除研发设备明细表
    exportRDEquipmentT:serverUrl+'/template/T',//生成研发设备明细表
    getRDProjectManageQ1:serverUrl+'/template/getQ1',//获取研发项目管理制度Q1
    updateRDProjectManage:serverUrl+'/template/updateQ1',//增加或修改研发项目管理制度Q1
    exportRDProjectManageQ1:serverUrl+'/template/Q1',//生成研发项目管理制度Q1
    getRDInvestManageQ2:serverUrl+'/template/getQ2',//获取研发投入核算管理制度Q2
    updateRDInvestManage:serverUrl+'/template/updateQ2',//修改研发投入核算管理制度Q2
    exportRDInvestManageQ2:serverUrl+'/template/Q2',//生成研发投入核算管理制度Q2
    getQ3:serverUrl+'/template/getQ3',//获取研发辅助账管理办法Q3
    updateQ3:serverUrl+'/template/updateQ3',//增加或修改研发辅助账管理办法Q3
    exportQ3:serverUrl+'/template/Q3',//生成研发辅助账管理办法Q3
    getQ4:serverUrl+'/template/getQ4',//获取企业研发准备金制度Q4
    updateQ4:serverUrl+'/template/updateQ4',//增加或修改企业研发准备金制度Q4
    exportQ4:serverUrl+'/template/Q4',//生成企业研发准备金制度Q4
    getQ5:serverUrl+'/template/getQ5',//获取科技成果转化的组织实施与激励奖励制度Q5
    updateQ5:serverUrl+'/template/updateQ5',//增加或修改科技成果转化的组织实施与激励奖励制度Q5
    exportQ5:serverUrl+'/template/Q5',//生成科技成果转化的组织实施与激励奖励制度Q5
    getQ6:serverUrl+'/template/getQ6',//获取开放式创新创业平台制度Q6
    updateQ6:serverUrl+'/template/updateQ6',//增加或修改开放式创新创业平台制度Q6
    exportQ6:serverUrl+'/template/Q6',//生成开放式创新创业平台制度Q6
    getQ7:serverUrl+'/template/getQ7',//获取科技人员培训管理制度Q7
    updateQ7:serverUrl+'/template/updateQ7',//增加或修改科技人员培训管理制度Q7
    exportQ7:serverUrl+'/template/Q7',//生成科技人员培训管理制度Q7
    getQ8:serverUrl+'/template/getQ8',//获取科技人员培养进修制度Q8
    updateQ8:serverUrl+'/template/updateQ8',//增加或修改科技人员培养进修制度Q8
    exportQ8:serverUrl+'/template/Q8',//生成科技人员培养进修制度Q8
    getQ9:serverUrl+'/template/getQ9',//获取人才引进制度Q9
    updateQ9:serverUrl+'/template/updateQ9',//增加或修改人才引进制度Q9
    exportQ9:serverUrl+'/template/Q9',//生成人才引进制度Q9
    getQ10:serverUrl+'/template/getQ10',//获取研发人员绩效考核制度Q10
    updateQ10:serverUrl+'/template/updateQ10',//增加或修改研发人员绩效考核制度Q10
    exportQ10:serverUrl+'/template/Q10',//生成研发人员绩效考核制度Q10
    getUsersByAdminArea:serverUrl+'/admin/getUsersByAdminArea',//普通管理员查看他所属区域的全部用户
    adminUpdateUser:serverUrl+'/admin/adminUpdateUser',//管理员修改用户信息
    adminDeleteUser:serverUrl+'/admin/adminDeleteUser',//管理员删除某一用户信息
    adminGetCompanyList:serverUrl+'/admin/companyList',//管理员查看某一用户的所有公司
    getAllUsers:serverUrl+'/admin/getAllUsers',//超级管理员查看所有用户信息
    getAreaUsers:serverUrl+'/admin/getAreaUsers',//超级管理员查看某一区域所有用户信息
    getAllAdmins:serverUrl+'/admin/getAllAdmins',//超级管理员查看所有普通管理员信息
    getAreaAdmins:serverUrl+'/admin/getAreaAdmins',//超级管理员查看某一区域所有普通管理员信息
    adminRightReduction: serverUrl + '/admin/adminRightReduction',//超级管理员将某一管理员降权至普通用户
    userRightRaising:serverUrl+'/admin/userRightRaising',//超级管理员将某一用户提升至管理员
    getTechnosphere: serverUrl + '/admin/getTechnosphere',//管理员查看所有技术领域
    addTechnosphere:serverUrl+'/admin/addTechnosphere',//管理员增加技术领域
    updateTechnosphere:serverUrl+'/admin/updateTechnosphere',//管理员修改技术领域
    deleteTechnosphere:serverUrl+'/admin/deleteTechnosphere',//管理员删除技术领域
    getAllUserArea:serverUrl+'/admin/getAllUserArea',//获取全部用户地区对象
    getAllUserAreaList:serverUrl+'/admin/getAllUserAreaList',//获取全部用户区域名称列表
    addUserArea:serverUrl+'/admin/addUserArea',//管理员添加用户地区
    getUserArea:serverUrl+'/admin/getUserArea',//管理员获取单个用户地区
    updateUserArea:serverUrl+'/admin/updateUserArea',//修改用户地区
    deleteUserArea:serverUrl+'/admin/deleteUserArea',//管理员删除用户地区
    getSysConfig:serverUrl+'/admin/getSysConfig',//管理员和系统获取系统名称和颜色搭配
    updateSysConfig:serverUrl+'/admin/updateSysConfig',//管理员修改系统名称和配色
    frozenAccount:serverUrl+'/admin/frozenAccount',//冻结账户
    activateAccount:serverUrl+'/admin/activateAccount',//解冻账户
    transferAccount:serverUrl+'/admin/transferAccount',//管理员转移账户
    uploadFile: serverUrl + '/file/upload',//文件上传
    downloadFile: serverUrl + '/file/downloadFile',//下载文件
    previewFile:serverUrl + '/file/previewFile',//预览路径
    checkFile:serverUrl + '/file/checkFile',//检测文件是否已经上传
    checkFileProcess:serverUrl +'/file/checkProcess',//检查文件是否已经生成
    exportPDF:serverUrl + '/file/exportPDF',//合并生成文件
    checkExport:serverUrl +  '/file/checkExport',//待合成文件状态
    deleteFile:serverUrl +  '/file/delete',//删除文件
    mergeReport:serverUrl + '/template/mergeReport',//财务审计报告和纳税申报表合并
    importStaff:serverUrl + '/template/importL',//导入人员花名册
    downloadUrl: 'http://114.55.27.39:8080/system/create/',//下载路径

}
